import React from "react";
import { connect } from "react-redux";
import { Actions as ACTIONS } from "@/store/actions/payslipActions";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "@/common/Modal";
import ListView, { Row } from "@/common/custom-lists/ListView";

const TaxModal = ({ modalStatus, closeModal, taxList, taxes }) => {
	return (
		<Modal
			status={modalStatus}
			close={closeModal}
			title={`${taxes?.[0]?.taxVariable?.taxName} Calculations`}
			width="70%"
		>
			<div className="block-content p-5">
				{taxes?.map((tax, index) => {
					const calculations = tax?.calculation || tax?.breakdown || [];
					return (
						<Table
							index={index}
							taxes={taxes}
							tax={tax}
							calculations={calculations}
						/>
					);
				})}
				<div className="col-xs-12 p-1 mb-2 mt-4">
					<div
						className="btn btn-danger pull-right"
						onClick={() => closeModal()}
					>
						Close
					</div>
				</div>
			</div>
		</Modal>
	);
};

const Table = ({ index, taxes, tax, calculations }) => {
	if (!tax || !taxes) return;

	const taxVariable = tax?.taxVariable;

	const category = taxVariable?.taxCategory || taxVariable?.nicCode || taxVariable?.taxCode;

	return (
		<div className={`col-xs-${taxes?.length > 1 ? "6" : "12"} ${index == 0 ? "pl-0 pr-2" : "pr-0 pl-2"}`}>
			<div
				className="col-xs-12 p-0"
				style={{ background: "#ECEEF1", borderRadius: 10 }}
			>
				<div className="p-4">
					<div
						className="col-xs-12 p-0 text-center"
						style={{
							fontSize: "1.5em",
							fontWeight: "550",
							padding: 5,
							paddingLeft: 10,
							paddingRight: 10,
							border: "1px solid #f7f7f7",
							borderRadius: "10px",
							boxShadow: "1px 1px 3px rgba(0, 0, 0, 0.2), 0 1px 2px rgba(0, 0, 0, 0.1)",
							backgroundColor: "white",
						}}
					>
						{`${
							tax?.taxVariable?.payer == "Both" ? "Employee & Employer" : tax?.taxVariable?.payer
						} Calculation ${category ? "(" + category + ")" : ""}`}
					</div>
				</div>

				<div className="clearfix" />
				{tax?.calculation && (
					<ListView
						{...{
							title: "Calculations",
							columns: [{ hidden: true }, "Calculation", "Result", { hidden: true }],
							items: [
								...calculations.map((calculation) => {
									return (
										<Row
											actionColumn={[0]}
											columns={[
												" ",
												calculation.substring(0, calculation.lastIndexOf("=")),
												calculation.substring(calculation.lastIndexOf("=") + 1),
												" ",
											]}
										/>
									);
								}),
								<div style={{ fontWeight: 650 }}>
									<Row
										actionColumn={[0]}
										columns={[" ", "Total", tax?.amount, " "]}
									/>
								</div>,
							],
						}}
					/>
				)}
				{tax?.breakdown && (
					<ListView
						{...{
							title: "Calculations",
							columns: [{ hidden: true }, "Calculation", "Result", { hidden: true }],
							items: [
								...calculations.map((breakdown) => {
									return breakdown?.calculation?.map((calculation) => {
										return (
											<Row
												actionColumn={[0]}
												columns={[
													" ",
													calculation.substring(0, calculation.lastIndexOf(":")),
													calculation.substring(calculation.lastIndexOf(":") + 1),
													" ",
												]}
											/>
										);
									});
								}),
								<div style={{ fontWeight: 650 }}>
									<Row
										actionColumn={[0]}
										columns={[" ", "Total", tax?.amount, " "]}
									/>
								</div>,
							],
						}}
					/>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state) => {
	const jurisdiction = state.company?.settings?.jurisdiction;
	const taxList = {
		UK: ["PAYE", "NIC", "Student Loan", "Pension"],
		MT: ["FSS", "SSC"],
	};

	const taxes = []

	state.payslipHistory?.taxModal?.tax?.forEach((tax) => {
		if (!tax.amount) return
		if (tax.taxVariable.payer === "Both") {
			taxes.push({ ...tax, taxVariable: { ...tax.taxVariable, payer: "Employee" } });
			taxes.push({ ...tax, taxVariable: { ...tax.taxVariable, payer: "Employer" } });
		} else {
			taxes.push(tax);
		}
	});

	return {
		modalStatus: state.payslipHistory?.taxModal?.show,
		taxes,
		taxList: taxList[jurisdiction],
	};
};

const mapDispatchToProps = (dispatch) => ({
	closeModal: () => dispatch(ACTIONS.setTaxModal({ show: false })),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxModal);
